import React from 'react';
import { useNavigate } from 'react-router-dom';

function App () {

    const navigate = useNavigate();
  
  	const back = () => {
    	navigate(-1); 
  	};
  

    return (
        <section class="error-page">
		<div class="container">
		  <div class="row align-items-center justify-content-center text-center" style={{height: '100vh', justifyContent: 'center', alignContent: 'center', alignItems: 'center'}}>
			  <div class="col-lg-7 col-md-10 col-12">
				  <div class="rounded10 p-50">
					  <h1 class="fs-100">404</h1>
					  <h1>Page Not Found !</h1>
					  <h3 class="text-fade">looks like, page doesn't exist</h3>
					  <div class="my-30"><a href="#" class="btn btn-primary" onClick={back}>Go Back</a></div>				  

					  <form class="search-form mx-auto mt-30 w-p75">
						<div class="input-group rounded5 overflow-h">
						  <input type="text" name="search" class="form-control bg-white" placeholder="Search" />
						  <button type="submit" name="submit" class="btn btn-primary btn-sm"><i class="fa fa-search"></i></button>
						</div>
					  </form>
				  </div>
			  </div>				
		  </div>
		</div>
	</section>
    );
} 

export default App;